// extracted by mini-css-extract-plugin
export default {"add_section_wrapper":"AddSection_add_section_wrapper__dz+0q","swiper_slide":"AddSection_swiper_slide__dj5pG","swiper":"AddSection_swiper__4PFYN"};